<div class="sec-title">
    <h1>Ajouter une Facture</h1>
</div>
<div><a class="btn btn-action" href="/factures" routerLink="/factures" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux factures</a></div>
<div style="width:100%;">
    <!--
<form [formGroup]="addSubmissionForm" (ngSubmit)="onSubmit(addSubmissionForm.value)" novalidate>
    
    <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Informations Soumission</legend>
        <div class="fieldset-wrap">
            <div class="float-lg-start col-sm-12 col-lg-5">
                <fieldset class="">
                    <legend class="sub-label">Info Client</legend>
                    <div class="infobox fieldset-wrap">
                        <div class="float-lg-start col-sm-12 col-lg-5">
                            <div class="form-group mb-3">
                                <label for="submission_no" class="form-label">Client</label>
                                John Smith
                            </div>

                            <div class="form-group mb-3">
                                <label for="purchase_date" class="form-label">Adresse principale</label>
                                365 Yvan Pavlov, Laval, Québec, H7M 4H6
                            </div>

                            <div class="form-group mb-3">
                                <label for="build_date" class="form-label">Langue</label>
                                Francais
                            </div>
                            <div class="form-group mb-3">
                                <label for="build_date" class="form-label">Courriel</label>
                                Mmagnan4@gmail.com
                            </div>
                        </div>
                        <div class="float-lg-end col-sm-12 col-lg-6">
                            <div class="form-group mb-3">
                                <label for="submission_no" class="form-label">Téléphone</label>
                                514-593-5012
                            </div>
                            <div class="form-group mb-3">
                                <label for="purchase_date" class="form-label">Cellulaire</label>
                                514-290-7968
                            </div>
                            <div class="form-group mb-3">
                                <label for="build_date" class="form-label">Tél. bureau</label>
                                514-290-7968
                            </div>
                        </div>
                        
                    </div>
                </fieldset>
            </div>
            <div class="float-lg-end col-sm-12 col-lg-6">
                <div class="sub-label">Rendez-vous soumission</div>
                <div class="form-group mb-3">
                    <label for="submission_no" class="form-label">Numéro de soumission</label>
                    <input type="text" class="form-control" name="submission_no" id="submission_no" formControlName="submission_no" />
                </div>
        
                <div class="form-group mb-3">
                    <label for="purchase_date" class="form-label">Date de création</label>
                    <input type="text" class="form-control date" name="purchase_date" id="purchase_date" formControlName="purchase_date" />
                </div>
        
                <div class="form-group mb-3">
                    <label for="build_date" class="form-label">Date des travaux</label>
                    <input type="text" class="form-control date" name="build_date" id="build_date" formControlName="build_date" />
                </div>
            </div>
        </div>
    </fieldset>
    
    <fieldset class="col-sm-12 col-lg-12 form-group mb-3">
        <legend>Adresse des travaux</legend>
        <div class="fieldset-wrap">
            <div class="float-lg-start col-sm-12 col-lg-5">
                <div class="form-group mb-3">
                    <label for="address" class="form-label">Adresse</label>
                    <input type="text" class="form-control" name="address" id="address" formControlName="address" />
                </div>
                
                <div class="form-group mb-3">
                    <label for="address2" class="form-label">Adresse 2</label>
                    <input type="text" class="form-control" name="address2" id="address2" formControlName="address2" />
                </div>
                
                <div class="form-group mb-3">
                    <label for="city" class="form-label">Ville</label>
                    <input type="text" class="form-control" name="city" id="city" formControlName="city" />
                </div>
            </div>
            <div class="float-lg-end col-sm-12 col-lg-6">
                <div class="form-group mb-3">
                    <label for="province" class="form-label">Province</label>
                    <input type="text" class="form-control" name="province" id="province" formControlName="province" />
                </div>
        
                <div class="form-group mb-3">
                    <label for="postalcode" class="form-label">Code postale</label>
                    <input type="text" class="form-control" name="postalcode" id="postalcode" formControlName="postalcode" />
                </div>
        
                <div class="form-group mb-3">
                    <label for="country" class="form-label">Pays</label>
                    <input type="text" class="form-control" name="country" id="country" formControlName="country" />
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Informations des travaux</legend>
        <div class="fieldset-wrap">
            <div class="float-lg-start col-sm-12 col-lg-5 ">
                <div class="form-group mb-3">
                    <label for="roof_type_id" class="form-label">Type de toit</label>
                    <select class="form-select" name="roof_type_id" id="roof_type_id" formControlName="roof_type_id">
                        <option *ngFor="let roofType of roofTypesList" [value]="roofType.roof_type_id">
                            {{roofType.name}}
                        </option>
                    </select>
                </div>

                <div class="form-group mb-3">
                    <label for="roof_access" class="form-label">Accès au toit</label>
                    <textarea class="form-control" name="roof_access" id="roof_access" formControlName="roof_access"></textarea>
                </div>
        
                <div class="form-group mb-3">
                    <label for="roof_description" class="form-label">Note type de toit</label>
                    <textarea class="form-control" name="roof_description" id="roof_description" formControlName="roof_description"></textarea>
                </div>
        
                <div class="form-group mb-3">
                    <label for="building_type_id" class="form-label">Type de maison</label>
                    <select class="form-select" name="building_type_id" id="building_type_id" formControlName="building_type_id">
                        <option *ngFor="let buildingType of buildingTypesList" [value]="buildingType.building_type_id">
                            {{buildingType.name}}
                        </option>
                    </select>
                </div>
        
                <div class="form-group mb-3">
                    <p class="form-label">Infiltration d'eau</p>
                    <textarea class="form-control" name="water_infiltration" id="water_infiltration" formControlName="water_infiltration"></textarea>
                </div>
            </div>
            <div class="float-lg-end col-sm-12 col-lg-6 ">
                <div  class="sub-label">Informations supplémentaire</div>
                    <div class="form-group mb-3">
                        <label for="owner_since" class="form-label">Propriétaire depuis combien d'années ?</label>
                        <input type="text" class="form-control date" name="owner_since" id="owner_since" formControlName="build_date" (click)="openCalendar(this)" />
                    </div>
        
                    <div class="form-group mb-3">
                        <label for="description" class="form-label">Note générale</label>
                        <textarea class="form-control" name="description" id="description" formControlName="description"></textarea>
                    </div>
            </div>
        </div>
      <div class="form-group mb-3">
            <p class="form-label">Infiltration d'eau</p>
            <textarea class="form-control" name="water_infiltration" id="water_infiltration" formControlName="water_infiltration"></textarea>
        </div>
    </fieldset>

    <button type="submit" class="btn btn-primary">Enregistrer</button>
</form>
-->
<hr />